<h2 mat-dialog-title>
  <mat-icon [color]="temPendencias() ? 'warn' : 'primary'">
    {{ temPendencias() ? 'warning' : 'info' }}
  </mat-icon>
  Pendências da {{ getNomeProva(data.tipoProva) }}
</h2>

<mat-dialog-content>
  <div class="pendencias-container">
    <div *ngIf="!temPendencias()" class="alerta-sucesso">
      <mat-icon>check_circle</mat-icon>
      <span>Todos os examinadores concluíram suas avaliações e depositaram seus envelopes.</span>
    </div>

    <mat-card *ngIf="temPendencias()" class="info-card">
      <mat-card-content>
        <p>Status de avaliação dos examinadores para esta prova:</p>
      </mat-card-content>
    </mat-card>

    <div class="examinadores-grid">
      <mat-card *ngFor="let examinador of data.examinadores" class="examinador-card"
                [ngClass]="{'card-completo': examinador.notasDigitadas === examinador.totalInscricoes && examinador.envelopeEnviado,
                            'card-pendente': examinador.notasDigitadas < examinador.totalInscricoes || !examinador.envelopeEnviado}">
        <mat-card-header>
          <div class="header-content">
            <mat-icon [color]="examinador.notasDigitadas === examinador.totalInscricoes && examinador.envelopeEnviado ? 'primary' : 'warn'">
              {{ examinador.notasDigitadas === examinador.totalInscricoes && examinador.envelopeEnviado ? 'check_circle' : 'pending' }}
            </mat-icon>
            <mat-card-title>{{ examinador.nome }}</mat-card-title>
          </div>
        </mat-card-header>
        <mat-card-content>
          <div class="status-item">
            <div class="status-label">
              <mat-icon>edit_note</mat-icon>
              <span>Notas digitadas:</span>
            </div>
            <div class="status-valor">
              <strong>{{ examinador.notasDigitadas }}/{{ examinador.totalInscricoes }}</strong>
              <span class="percentual" [ngClass]="{'completo': examinador.notasDigitadas === examinador.totalInscricoes}">
                ({{ getProgressoPercentual(examinador) }}%)
              </span>
            </div>
          </div>

          <mat-progress-bar 
            mode="determinate" 
            [value]="getProgressoPercentual(examinador)"
            [color]="examinador.notasDigitadas === examinador.totalInscricoes ? 'primary' : 'warn'">
          </mat-progress-bar>

          <div class="status-item envelope-status">
            <div class="status-label">
              <mat-icon>mail</mat-icon>
              <span>Envelope:</span>
            </div>
            <div class="status-badge" [ngClass]="{'badge-enviado': examinador.envelopeEnviado, 'badge-pendente': !examinador.envelopeEnviado}">
              <mat-icon>{{ examinador.envelopeEnviado ? 'check_circle' : 'cancel' }}</mat-icon>
              <span>{{ examinador.envelopeEnviado ? 'Depositado' : 'Pendente' }}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div *ngIf="temPendencias()" class="alerta-info">
      <mat-icon>info</mat-icon>
      <span>Todos os examinadores devem concluir suas avaliações e depositar seus envelopes antes de prosseguir.</span>
    </div>

    <div *ngIf="data.reportesPendentes" class="alerta-reporte">
      <mat-icon>announcement</mat-icon>
      <span>Há <strong>{{ data.reportesPendentes }}</strong> {{ data.reportesPendentes === 1 ? 'suspeita de identificação do candidato pendente de análise' : 'suspeitas de identificação do candidato pendentes de análise' }}. Acesse a <a [routerLink]="['/comissao-julgadora/listar-notas', data.concursoId, 'ESCRITA']" (click)="fechar()">prova</a> para decidir.</span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="fechar()">
    <mat-icon>close</mat-icon>
    Fechar
  </button>
</mat-dialog-actions>
